<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">材料退库申请</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="130px" class="form">
          <material-back ref="create" :userData="userData" :formByFather="form"></material-back>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments ref="attachments" style="margin-left:-10px;" :arr="attachmentArr" :type='50'></attachments>
            </el-form-item>
          </div>


          <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <approval-item-by-custom ref="approval" :defaultApprovalUsers="defaultApprovalUsers" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item-by-custom>
            <!-- 审批
            <approval-item ref="approval" :approvalUsers="approvalUsers.c50" :selectArr="selectArr" :approvalSetDep="approvalSetDep"></approval-item> -->

          </div>


          <el-form-item label="">
            <el-button :loading="formLoading" @click="SubmitMaterial()" class="form-btn" type="success">确认提交材料退库申请
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>


  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  // import approvalUsers from '@/Mixins/approvalUsers'
  import ApprovalItemByCustom from '../../components/ApprovalItemByCustom'

  import Attachments from '@/components/Attachments'
  import ApprovalItem from '@/components/ApprovalItem'

  import MaterialBack from '@/page/form/materialBack'
  export default {
    components: {
      ApprovalItemByCustom,
      MaterialBack,
      ApprovalItem,
      Attachments,
    },
    // mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        formLoading: false,
        form: {
          houseId: '',
          projectId: '',
          customer: '',
          materials: [],
          json: true,
        },
        // 附件
        attachmentArr: [],
        // 审批
        approvalType: "0",

        defaultApprovalUsers: "",
        selectArr: [],
        approvalSetDep: {},
      }
    },
    created() {
      if (this.$route.params.houseId && this.$route.params.houseId != 0) {
        this.form.houseId = this.$route.params.houseId / 1
      }
      if (this.$route.params.projectId) {
        this.form.projectId = this.$route.params.projectId / 1
      }
      // this.form.time = this.getNowTime()


      // 编辑
      if (this.$route.query.applyId) {
        this.form.applyId = this.$route.query.applyId / 1
        this.formLoading = true
        this.getApplyInfo()
      }
    },
    methods: {
      // 获取原审批表内容
      getApplyInfo() {
        ajax.get('/storage/material/back/apply/info/' + this.form.applyId, {}, (res) => {
          this.applyInfo = res.vo

          this.form = this.applyInfo
          this.form.applyId = this.form.flow.applyId
          this.form.houseId = this.form.house.id
          this.form.json = true

          let _materials = []
          for (var i = 0; i < this.form.materials.length; i++) {
            let _material = this.form.materials[i]
            let material = {
              material: {
                name: _material.name,
                unit: {
                  name: _material.unitName,
                  id: _material.unitId,
                },
                number: _material.number,
              },
            }
            _materials.push({
              material: material,
              amount: _material.amount,
              backNum: _material.canBackNum,
              materialId: _material.materialId,
            })
          }
          console.log(_materials)
          this.form.materials = _materials

          this.attachmentArr = this.applyInfo.attachments ? this.applyInfo.attachments : []

          this.selectArr = this.form.flow.approvals.map(item => item.user)
          this.formLoading = false
        })
      },
      // 自动插入现有时间
      plusZero(s) {
        return s < 10 ? '0' + s : s;
      },
      getNowTime() {
        let _s = ""
        let _time = new Date()
        _s += _time.getFullYear() + "-"
        _s += this.plusZero(_time.getMonth() + 1) + "-"
        _s += this.plusZero(_time.getDate()) + " "
        _s += this.plusZero(_time.getHours()) + ":"
        _s += this.plusZero(_time.getMinutes()) + ":"
        _s += "00"
        return _s
      },
      // 提交使用材料申请单
      SubmitMaterial() {
        this.form = this.$refs.create.getFromData()

        if (!this.form.time) {
          this.$message.error('退库时间必须填写')
          return
        }
        this.form.approvalType = this.approvalType
        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        if (!this.form.approvalUserIds) {
          this.$message.error('审批人员不能一个都不选择')
          return
        }
        this.form.attachments = this.$refs.attachments.getAttachments()

        this.formLoading = true
        let _url = !this.form.applyId ? '/storage/material/back/apply' : '/storage/material/back/apply/edit?applyId=' +
          this.form.applyId

        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          if (!this.form.applyId) {
            this.$message.success("提交材料退库申请成功，请耐心等待领导审批")
          } else {
            this.$message.success("修改材料退库申请成功，请耐心等待领导审批")
          }
          this.$router.push('/Storage/MaterialBackList/' + this.form.houseId)
        }, (res) => {
          this.formLoading = false
        })
      },
    },
  }

</script>



// WEBPACK FOOTER //
// src/page/storage/materialBack.vue